import { render } from "./VaPageNotFoundSimple.vue?vue&type=template&id=625d49d6"
import script from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"

import "./VaPageNotFoundSimple.vue?vue&type=style&index=0&id=625d49d6&lang=scss"
script.render = render

export default script